import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {PaymentMethodDetails, TPayByBankAppPaymentMethodStore} from '@/pages/payment-methods'
import {PaymentMethodsPayByBankAppStoreSymbol} from '@/pages/payment-methods/PaymentMethods/PaymentMethods'
import {PaymentMethodType} from '@/constants'
import {COMPANY_NAME} from '@/constants/app'
export const PayByBankAppPaymentMethod = observer(() => {
    const { t } = useTranslation()
    const store = useInjection<TPayByBankAppPaymentMethodStore>(PaymentMethodsPayByBankAppStoreSymbol)

    return <PaymentMethodDetails
        title={t('PayByBankAppPaymentMethod.title')}
        description={<Trans
            i18nKey='PayByBankAppPaymentMethod.description'
            components={{ br: <br/> }}
            values={{companyName: COMPANY_NAME}}
        />}
        paymentMethodType={PaymentMethodType.paybybankapp}
        stores={store.stores}
    />
})
